module.exports = __webpack_public_path__ + "img/twitter.abb5986.svg";